<template>
  <NavMenu />
  <router-view :key="$route.path" />
  <Footer />
</template>

<script>
import NavMenu from './components/NavMenu.vue';
import Footer from './views/Footer.vue';

export default {
  name: 'App',
  components: {
    NavMenu,
    Footer
  },
};
</script>
